import React from "react";
import { Text } from "$components";
import CField from "$forms/CField";
import { useUserFormContext } from "../context/UserFormContext";
import { useStyles } from "./styles";
import {
  AT_LEAST_ONE_PHONE_ERROR_MSG,
  useUserFormLogic,
} from "../hooks/useUserFormLogic";

export const UserFormPhones: React.FC = () => {
  const { form, canHaveTwoPhones } = useUserFormContext();
  const { atLeastOnePhone } = useUserFormLogic();
  const {
    control,
    formState: { errors },
  } = form;
  const classes = useStyles();

  return (
    <>
      {canHaveTwoPhones && (
        <div className={classes.fieldsRow}>
          <Text>Remplir au moins un des deux numéros *</Text>
        </div>
      )}
      <div
        className={canHaveTwoPhones ? classes.thinFieldsRow : classes.fieldsRow}
      >
        <CField
          label={canHaveTwoPhones ? "Téléphone mobile" : "Téléphone"}
          control={control}
          name="phone"
          error={errors.phone}
          required={!canHaveTwoPhones}
          rules={{
            pattern: {
              value: /^([0-9]){1,10}$/,
              message: "Veuillez saisir un numéro de téléphone valide",
            },
            validate: {
              atLeastOnePhone: () =>
                !canHaveTwoPhones ||
                atLeastOnePhone() ||
                AT_LEAST_ONE_PHONE_ERROR_MSG,
            },
          }}
        />
      </div>
      {canHaveTwoPhones && (
        <div className={classes.fieldsRow}>
          <CField
            label="Téléphone fixe"
            control={control}
            name="phone2"
            error={errors.phone2}
            rules={{
              pattern: {
                value: /^([0-9]){1,10}$/,
                message: "Veuillez saisir un numéro de téléphone valide",
              },
            }}
          />
        </div>
      )}
    </>
  );
};
